import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #d2a97a;
`;

const NavLogo = styled(Link)`
  color: #000;
  font-size: 2rem;
  text-decoration: none;
  font-weight: bold;
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
`;

const NavItem = styled(Link)`
  color: #333;
  font-size: 1.2rem;
  text-decoration: none;
  margin-left: 20px;
  &:hover {
    color: #000;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

const SocialIcon = styled.a`
  color: #333;
  font-size: 1.5rem;
  text-decoration: none;
  margin-left: 10px;
  &:hover {
    color: #000;
  }
`;

function Navbar() {
  return (
    <Nav>
      <NavLogo to="/">艺苑</NavLogo>
      <NavMenu>
        <NavItem to="/about">关于</NavItem>
        <NavItem to="/contact">接触</NavItem>
        <NavItem to="/blog">博客</NavItem>
        <SocialIcons>
          <SocialIcon href="https://instagram.com" target="_blank">Instagram</SocialIcon>
          <SocialIcon href="https://twitter.com" target="_blank">Twitter</SocialIcon>
        </SocialIcons>
      </NavMenu>
    </Nav>
  );
}

export default Navbar;
